import type {
  SilkImageDataTransferObject,
  SilkImagesDataTransferObject,
} from '@mobi/api-types/racePage/types'
import type { ObservableFinisher } from '../Model/Observables/ObservableFinisher'
import type { ObservableStarter } from '../Model/Observables/ObservableStarter'
import { SilkImage, SilkImageSize, SilkImages } from '../Model/SilkImages'

export default {
  map(dto: SilkImagesDataTransferObject, model: ObservableStarter | ObservableFinisher) {
    const silks = new SilkImages()
    silks.small = mapSilkImage(dto.small)
    silks.large = mapSilkImage(dto.large)
    model.silkImages(silks)
  },
}

function mapSilkImage(dto: SilkImageDataTransferObject): SilkImage {
  const silkImage = new SilkImage()
  silkImage.url = dto.url
  silkImage.size = new SilkImageSize()
  silkImage.size.width = dto.size.width
  silkImage.size.height = dto.size.height
  silkImage.size.y = dto.size.y
  return silkImage
}
